import React, { Component } from 'react';
import { Container, Row, Col, FormControl, Image, Dropdown, DropdownButton, Form, Button, Pagination, ButtonToolbar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import NavbarComponent from '../Navbar/index';
import RenovateTokenAlert from '../../RenovateToken';
import ReactNotification from 'react-notifications-component';
import { store } from 'react-notifications-component';
import Backend from '../../Backend';
import { CSVLink } from "react-csv";
import SearchImage from '../../Images/search.svg';
import Connection from '../../Calls';

var date = new Date();
// var HeightScreen = window.screen.height;

class TransactionsIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {
      idWallet: '',
      search: '',
      orderBySelect: props.traductions.General.filtros.Date_newest,
      sendOrderBySelect: 'date_new',
      numeroFilas: 25,
      paginaActual: 1,
      walletslistpagination: [],
      dateFrom: '',
      dateTo: '',
      dataExported: []
    }
  }

  componentWillMount() {
    this.walletsPagination(this.state.paginaActual, this.state.numeroFilas, this.state.sendOrderBySelect);
  }

  walletsPagination(value_paginaActual, value_numeroFilas, value_orderbyfilter) {
    const self = this;
    var fechaInicio = "";
    var fechaFinal = "";
    self.setState({ showLoad: true, paginaActual: value_paginaActual, numeroFilas: value_numeroFilas, sendOrderBySelect: value_orderbyfilter });
    if (self.state.dateFrom !== "") {
      fechaInicio = this.state.dateFrom + ' 00:00:00';
    }
    if (self.state.dateTo !== "") {
      fechaFinal = this.state.dateTo + ' 23:59:59';
    }

    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.TransactionPerAccount(localStorage.getItem('email'), localStorage.getItem('token'), value_numeroFilas, value_paginaActual, response.payload.r01, this.state.search, fechaInicio, fechaFinal, value_orderbyfilter, response => {
        if (response.status.code === "0") {
          self.setState({
            walletslistpagination: response.payload.transactions_list,
            dataLength: Math.ceil(response.payload.total_amount / value_numeroFilas),
            showLoad: false
          });
        } else {
          self.setState({
            walletslistpagination: [],
            showLoad: false
          });
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }
      });
    });
    self.dataCsvTransaction();
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.setState({ walletslistpagination: [] })
      this.walletsPagination(1, this.state.numeroFilas, this.state.sendOrderBySelect);
    }
  }

  changePage(value) {
    this.setState({
      paginaActual: value,
    });
    this.walletsPagination(value, this.state.numeroFilas, this.state.sendOrderBySelect);
  }

  BlockchainLinks(coin, tx, label) {

    var isInternal= label.indexOf('[IT]')
    if(isInternal == -1){
      switch (coin) {
        case "btc":
          return 'https://www.blockchain.com/en/btc/tx/' + tx; // + '/';
        case "ltc":
          return 'https://blockchair.com/litecoin/transaction/' + tx + '/';
        case "dash":
          return 'https://explorer.dash.org/insight/tx/' + tx + '/';
        case "eth":
          return 'https://etherscan.io/tx/' + tx;
        case "bch":
          return 'https://explorer.bitcoin.com/bch/tx/' + tx + '/';
        case "xrp":
          return 'https://livenet.xrpl.org/transactions/' + tx;
        case "usdt":
          return 'https://solscan.io/tx/' + tx;
        case "sol":
          return 'https://solscan.io/tx/' + tx;
        default:
          return '';
      }
    }else{
      return process.env.REACT_APP_ME_WEB+'transferview?id=' + tx
    }
  }

  renderListWallets() {
    const self = this;
    var users = [];
    self.state.walletslistpagination.forEach(function (row) {
      var text_type_transaction;
      if (row.category === "deposit") {
        text_type_transaction = <td className="text-table-container-addres-information" style={{ color: "#4EC95E", textTransform: "capitalize" }}>{row.category}</td>;
        } else if (row.category === "withdrawal") {
          text_type_transaction = <td className="text-table-container-addres-information" style={{ color: "#FB5B5A", textTransform: "capitalize" }}>{row.category}</td>;
          } else {
            text_type_transaction = <td className="text-table-container-addres-information" style={{ color: "#053064", textTransform: "capitalize" }}>{row.category}</td>;
            }

            users.push(
              <ButtonToolbar style={{ display: "contents" }}>
                <OverlayTrigger
                  key="top"
                  placement="top"
                  overlay={
                    <Tooltip
                      id="tooltip-top"
                      >
                      {self.props.traductions.transacciones.tooltip_hover}: {row.wallet_alias}
                    </Tooltip>
                  }
                  >
                  <tr className="hover-tr-table-wallets-generals" style={{ cursor: "default" }}>
                    <td><Image src={require("../../CryptoIcons/" + row.coin + ".svg")} className="icon-crypto-svg" /></td>
                    <td className="text-table-container-addres-information">{row.address}</td>
                    {text_type_transaction}
                    <td className="text-table-container-addres-information">{row.label}</td>
                    <td className="text-table-container-addres-information">{row.status}</td>
                    <td className="text-table-container-addres-information">{row.amount} {row.coin.toUpperCase()}</td>
                      <td className="text-table-container-addres-information">
                      {
                        (row.coin === 'mxn' || row.coin === 'usd') ?
                        ''
                        :`≈ ${row.usd_value}`
                      }
                      </td>
                    <td className="text-table-container-addres-information">{row.date}</td>
                    <td className="text-table-container-addres-information">
                      <div className="three-dots-txid">
                        <a target={"_blank"} href={self.BlockchainLinks(row.coin, row.txid, row.label)}>{row.txid}</a>
                      </div>
                    </td>
                  </tr>
                </OverlayTrigger>
              </ButtonToolbar>
            );
          });
          return users;
  }

  dataCsvTransaction() {
    const self = this;
    var data = [];

    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.TransactionPerAccount(localStorage.getItem('email'), localStorage.getItem('token'), 9999, 1, response.payload.r01, '', this.state.dateFrom, this.state.dateTo, this.state.orderBySelect, response => {
        if (response.status.code === "0") {
          response.payload.transactions_list.forEach(function (row) {
            data.push(row);
          });
          self.setState({ dataExported: data });
        } else {
          self.setState({
            dataExported: []
          });
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }
      });
    });
  }

  render() {
    return (
      <div>
        <NavbarComponent data={this.props} selected="transactions" logged={true} />
        <RenovateTokenAlert data={this.props} />
        <div className="contenedor-wallets-generals" style={{ paddingLeft: 10, paddingRight: 10 }}>
          <div className="container-transactions" style={{ width: "100%" }}>
            <div className="border-title-separator-container">
              <div className="border-title-separator-container-left">
                <p className="title-container-shadow">{this.props.traductions.transacciones.title}</p>
              </div>
              <div className="border-title-separator-container-right">
                <CSVLink className="subtitle-container-shadow link-transactions" data={this.state.dataExported} filename={'account-transactions-' + date + '.csv'}>{this.props.traductions.transacciones.exportCSV}</CSVLink>
              </div>
            </div>
            <div style={{ marginBottom: 50 }}>
              <Container fluid>
                <Row>
                  <Col md={4} className='virtual_exchange_dropdown'>
                    <Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.transacciones.L_sort}:</Form.Label>
                    <DropdownButton title={this.state.orderBySelect}>
                      <Dropdown.Item onClick={() => { this.setState({ orderBySelect: this.props.traductions.General.filtros.Date_newest }); this.walletsPagination(1, 25, "date_new"); }} as="button">{this.props.traductions.General.filtros.Date_newest}</Dropdown.Item>
                      <Dropdown.Item onClick={() => { this.setState({ orderBySelect: this.props.traductions.General.filtros.Date_older }); this.walletsPagination(1, 25, "date_old"); }} as="button">{this.props.traductions.General.filtros.Date_older}</Dropdown.Item>
                      <Dropdown.Item onClick={() => { this.setState({ orderBySelect: this.props.traductions.General.filtros.Amount_lower }); this.walletsPagination(1, 25, "amount_low"); }} as="button">{this.props.traductions.General.filtros.Amount_lower}</Dropdown.Item>
                      <Dropdown.Item onClick={() => { this.setState({ orderBySelect: this.props.traductions.General.filtros.Amount_bigger }); this.walletsPagination(1, 25, "amount_big"); }} as="button">{this.props.traductions.General.filtros.Amount_bigger}</Dropdown.Item>
                      <Dropdown.Item onClick={() => { this.setState({ orderBySelect: this.props.traductions.General.filtros.Category_received }); this.walletsPagination(1, 25, "cat_rcvd"); }} as="button">{this.props.traductions.General.filtros.Category_received}</Dropdown.Item>
                      <Dropdown.Item onClick={() => { this.setState({ orderBySelect: this.props.traductions.General.filtros.Category_withdrawal }); this.walletsPagination(1, 25, "cat_with"); }} as="button">{this.props.traductions.General.filtros.Category_withdrawal}</Dropdown.Item>
                    </DropdownButton>
                  </Col>
                  <Col md={4} className='virtual_exchange_dropdown'>
                    <Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.transacciones.L_dateF}:</Form.Label>
                    <FormControl
                      type="date"
                      className="input-signup"
                      value={this.state.dateFrom}
                      onChange={(dateFrom) => { this.setState({ dateFrom: dateFrom.target.value }) }}
                      />
                  </Col>
                  <Col md={4} className='virtual_exchange_dropdown'>
                    <Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.transacciones.L_dateT}:</Form.Label>
                    <FormControl
                      type="date"
                      className="input-signup"
                      value={this.state.dateTo}
                      onChange={(dateTo) => { this.setState({ dateTo: dateTo.target.value }) }}
                      />
                  </Col>
                  <Col md={11} className='virtual_exchange_dropdown'>
                    <Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.transacciones.L_search}:</Form.Label>
                    <Form.Control style={{ height: 40 }} className="input-signup" type="text" placeholder={this.props.traductions.transacciones.L_search} value={this.state.search} onKeyPress={this.handleKeyPress} onChange={(search) => { this.setState({ search: search.target.value }) }} />
                  </Col>

                  <Col md={1}>
                    <div style={{ paddingTop: 24, textAlign:'center'}}>
                      <Button className="signup-button" style={{ height: 40, width:40, padding: 0 }} onClick={() => { this.walletsPagination(1, 25, "date_new"); }}>
                        <Image src={SearchImage} style={{ width: 20, marginTop:-4 }} />
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
            <div className="scroll-table-wallets-generals transactions-table-height">
              <table className="table-container-wallets-generals">
                <thead>
                  <tr>
                    <th className="header-table-wallets-generals fixxxed"></th>
                    <th className="header-table-wallets-generals fixxxed">{this.props.traductions.transacciones.T_H_WA}</th>
                    <th className="header-table-wallets-generals fixxxed">{this.props.traductions.transacciones.T_H_category}</th>
                    <th className="header-table-wallets-generals fixxxed">{this.props.traductions.transacciones.T_H_label}</th>
                    <th className="header-table-wallets-generals fixxxed">{this.props.traductions.transacciones.T_H_status}</th>
                    <th className="header-table-wallets-generals fixxxed">{this.props.traductions.transacciones.T_H_amount}</th>
                    <th className="header-table-wallets-generals fixxxed">{/*this.props.traductions.transacciones.T_H_USDamount*/}</th>
                    <th className="header-table-wallets-generals fixxxed">{this.props.traductions.transacciones.T_H_date}</th>
                    <th className="header-table-wallets-generals fixxxed">{this.props.traductions.transacciones.T_H_txid}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.renderListWallets()}
                </tbody>
              </table>
            </div>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 40 }}>
              <DropdownButton id="dropdown-item-button-step1" title={this.state.numeroFilas}>
                <Dropdown.Item onClick={() => { this.setState({ numeroFilas: 25 }); this.walletsPagination(1, 25, "date_new"); }} as="button">25</Dropdown.Item>
                <Dropdown.Item onClick={() => { this.setState({ numeroFilas: 50 }); this.walletsPagination(1, 50, "date_new"); }} as="button">50</Dropdown.Item>
                <Dropdown.Item onClick={() => { this.setState({ numeroFilas: 100 }); this.walletsPagination(1, 100, "date_new"); }} as="button">100</Dropdown.Item>
              </DropdownButton>

              <Pagination>
                <Pagination.First disabled={this.state.paginaActual === 1 || this.state.spinner} onClick={() => {
                    if (this.state.paginaActual !== 0) {
                      this.changePage(1);
                    }
                  }} />
                  <Pagination.Prev disabled={this.state.paginaActual === 1 || this.state.spinner} onClick={() => {
                      if (this.state.paginaActual !== 0) {
                        this.changePage(this.state.paginaActual - 1);
                      }
                    }} />
                    {this.state.paginaActual > 2 &&
                      <Pagination.Item disabled={this.state.spinner} onClick={() => { this.changePage(this.state.paginaActual - 2) }}>{this.state.paginaActual - 2}</Pagination.Item>
                    }
                    {this.state.paginaActual > 1 &&
                      <Pagination.Item disabled={this.state.spinner} onClick={() => { this.changePage(this.state.paginaActual - 1) }}>{this.state.paginaActual - 1}</Pagination.Item>
                    }
                    <Pagination.Item active>{this.state.paginaActual}</Pagination.Item>
                    {this.state.paginaActual < this.state.dataLength &&
                      <Pagination.Item disabled={this.state.spinner} onClick={() => { this.changePage(this.state.paginaActual + 1) }}>{this.state.paginaActual + 1}</Pagination.Item>
                    }
                    {this.state.paginaActual < this.state.dataLength - 1 &&
                      <Pagination.Item disabled={this.state.spinner} onClick={() => { this.changePage(this.state.paginaActual + 2) }}>{this.state.paginaActual + 2}</Pagination.Item>
                    }
                    <Pagination.Next disabled={this.state.paginaActual >= this.state.dataLength || this.state.spinner} onClick={() => {
                        if (this.state.paginaActual < this.state.dataLength) {
                          this.changePage(this.state.paginaActual + 1)
                        }
                      }} />
                      <Pagination.Last disabled={this.state.paginaActual >= this.state.dataLength || this.state.spinner} onClick={() => {
                          if (this.state.paginaActual < this.state.dataLength) {
                            this.changePage(this.state.dataLength)
                          }
                        }} />
                      </Pagination>
                    </div>
          </div>
        </div>

      </div >
    );
  }
} export default TransactionsIndex;
